export interface SiteCssVariables {
    '--vh': string;
}

export const siteCssVariables: SiteCssVariables = {
    '--vh': '100vh',
};
